import { SET_ALERT, REMOVE_ALERT } from '../actions/index';

const initialState = {
  message: '',
  status: '',
  isVisible: false,
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALERT:
      return {
        ...state,
        message: action.payload.message,
        status: action.payload.status,
        isVisible: true,
      };
    case REMOVE_ALERT:
      return {
        ...state,
        message: '',
        status: '',
        isVisible: false,
      };
    default:
      return state;
  }
};

export default alertReducer;